import { alias, createModelSchema } from "serializr";
import { Schema } from "@/common/Schema";

import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";
import { RedactorUtils } from "@/modules/redactor/core/RedactorUtils";

export class SmartOfferBundleMasterSeason extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.MASTER_SEASON);

        this._productChest = null;
    }

    get productChest() {
        return this._productChest;
    }

    set productChest(value) {
        this._productChest = value;
    }

    valid() {

        if (!this.productChest || !RedactorUtils.getProduct(this.productChest)) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.productChest) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleMasterSeason());
        } else if (target instanceof SmartOfferBundleMasterSeason) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleMasterSeason, {
    _productChest: alias("product_chest", Schema.primitive())
});
